const ANALYZE_EMMIT_EVENT_TO_TEALIUM = 'ANALYZE_EMMIT_EVENT_TO_TEALIUM';
const ANALYZE_EMMIT_VIEW_TO_TEALIUM = 'ANALYZE_EMMIT_VIEW_TO_TEALIUM';
const ANALYZE_EVENT = 'ANALYZE_EVENT';
const ANALYZE_VIEW = 'ANALYZE_VIEW';

export {
  ANALYZE_EMMIT_EVENT_TO_TEALIUM,
  ANALYZE_EMMIT_VIEW_TO_TEALIUM,
  ANALYZE_EVENT,
  ANALYZE_VIEW,
};
